var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.584 11.6119L10.0492 2.02517C9.14517 0.441479 6.85906 0.441479 5.95827 2.02517L0.420228 11.6119C-0.483809 13.1956 0.64136 15.163 2.46569 15.163H13.519C15.3434 15.163 16.488 13.1761 15.584 11.6119ZM8.00049 13.0362C7.5192 13.0362 7.11921 12.6362 7.11921 12.1549C7.11921 11.6737 7.5192 11.2737 8.00049 11.2737C8.48177 11.2737 8.88176 11.6737 8.86225 12.1777C8.88501 12.6362 8.46226 13.0362 8.00049 13.0362ZM8.80371 7.33883C8.76469 8.02174 8.72242 8.70139 8.68339 9.3843C8.66388 9.60543 8.66388 9.80705 8.66388 10.0249C8.64437 10.3859 8.36145 10.6656 8.00049 10.6656C7.63952 10.6656 7.35986 10.4054 7.33709 10.0444C7.27856 8.98106 7.21677 7.93719 7.15824 6.87381C7.13872 6.59414 7.11921 6.31122 7.09645 6.03155C7.09645 5.56978 7.3566 5.1893 7.77936 5.06898C8.20211 4.96817 8.62161 5.16979 8.80371 5.56978C8.8655 5.70961 8.88501 5.84945 8.88501 6.01204C8.8655 6.45756 8.82323 6.89982 8.80371 7.33883Z",
    fill: "#B3B3B3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.a95d2ea9.svg";
export { ForwardRef as ReactComponent };